import { Mail, MessageCircle, PhoneCall } from "lucide-react";

import { LANDING_CONTACT } from "../../config/landingPricing";

export function LandingContactSection() {
  return (
    <section className="scroll-mt-24 bg-white py-20 sm:py-28" id="contact">
      <div className="mx-auto grid max-w-7xl gap-10 px-5 lg:grid-cols-[.8fr_1.2fr] lg:px-8">
        <div>
          <p className="text-xs font-bold tracking-[0.16em] text-orange-600">CONTACT</p>
          <h2 className="mt-4 font-display text-4xl font-black text-blue-950 sm:text-5xl">
            Let’s talk about your society.
          </h2>
          <p className="mt-5 max-w-md text-base leading-relaxed text-slate-600">
            Talk to our team about a Society ERP demo, onboarding, or joining the professional network.
          </p>
        </div>
        <div className="grid gap-4 sm:grid-cols-3">
          <div className="border border-slate-200 bg-slate-50 p-5">
            <span className="flex h-11 w-11 items-center justify-center bg-blue-100 text-blue-800"><PhoneCall className="h-5 w-5" /></span>
            <p className="mt-4 text-xs font-bold tracking-[0.12em] text-slate-500">CALL US</p>
            <div className="mt-3 text-sm font-bold text-blue-950">
              {LANDING_CONTACT.phones.map((phone, index) => (
                <span key={phone.href}>
                  {index > 0 && <span className="px-1.5 text-slate-400">|</span>}
                  <a
                    className="hover:text-orange-600"
                    data-testid={`landing-contact-${phone.label.replaceAll("-", "")}`}
                    href={phone.href}
                  >
                    {phone.label}
                  </a>
                </span>
              ))}
            </div>
          </div>
          <a className="border border-slate-200 bg-slate-50 p-5 transition-[transform,box-shadow] duration-300 hover:-translate-y-1 hover:shadow-md" data-testid="landing-contact-whatsapp" href={LANDING_CONTACT.whatsappHref} rel="noreferrer" target="_blank">
            <span className="flex h-11 w-11 items-center justify-center bg-emerald-100 text-emerald-700"><MessageCircle className="h-5 w-5" /></span>
            <p className="mt-4 text-xs font-bold tracking-[0.12em] text-slate-500">WHATSAPP</p>
            <p className="mt-3 text-sm font-bold text-blue-950">8080-220-880</p>
            <p className="mt-2 text-xs leading-relaxed text-slate-600">Message our verified WhatsApp business contact.</p>
          </a>
          <a className="border border-slate-200 bg-slate-50 p-5 transition-[transform,box-shadow] duration-300 hover:-translate-y-1 hover:shadow-md" data-testid="landing-contact-email" href={`mailto:${LANDING_CONTACT.email}`}>
            <span className="flex h-11 w-11 items-center justify-center bg-orange-100 text-orange-700"><Mail className="h-5 w-5" /></span>
            <p className="mt-4 text-xs font-bold tracking-[0.12em] text-slate-500">EMAIL</p>
            <p className="mt-3 break-all text-sm font-bold text-blue-950">{LANDING_CONTACT.email}</p>
            <p className="mt-2 text-xs leading-relaxed text-slate-600">We will route your enquiry to the right team.</p>
          </a>
        </div>
      </div>
    </section>
  );
}

export function FloatingWhatsAppControl() {
  return (
    <a aria-label="Chat with MySocietyMitra on WhatsApp" className="fixed bottom-5 right-5 z-40 flex h-12 w-12 items-center justify-center rounded-full bg-emerald-600 text-white shadow-lg shadow-emerald-900/20 transition-[transform,background-color] duration-200 hover:-translate-y-1 hover:bg-emerald-700 focus:outline-none focus:ring-2 focus:ring-emerald-300" data-testid="landing-floating-whatsapp" href={LANDING_CONTACT.whatsappHref} rel="noreferrer" target="_blank">
      <MessageCircle className="h-6 w-6" />
    </a>
  );
}